'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import withPauseAndHelpLogic from '../higherOrderComponents/withPauseAndHelpLogic';
import { loadWistiaApi } from 'ui-addon-video-player/utils/loadPlayerApi';
import { jsx as _jsx } from "react/jsx-runtime";
class WistiaVideoPlayer extends Component {
  constructor(props) {
    super(props);
    this.mostRecentBound = '';
    this.unbindWistiaVideoEvents = this.unbindWistiaVideoEvents.bind(this);
    this.bindWistiaVideoEvents = this.bindWistiaVideoEvents.bind(this);
    if (!window.Wistia) {
      loadWistiaApi();
    }
  }
  componentDidMount() {
    // It's safe to push things onto `window._wq` at any time, even before Wistia has loaded.
    // Once it has loaded, it will grab the videos out of the queue
    window._wq = window._wq || [];
    window._wq.push({
      id: this.props.videoId,
      options: this.getOptionsFromProps(this.props.color, this.props.autoPlay, this.props.captionsOnByDefault),
      onReady: video => {
        this.props.cancelHelpTextTimeout();
        this.bindWistiaVideoEvents(video);
        video.playbackRate(this.props.videoPlaySpeed / 100);
        if (this.props.autoPlay) {
          video.play();
        }
        if (this.props.onReady) {
          this.props.onReady();
        }
        return video.unbind;
      }
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.videoId !== this.props.videoId && window.Wistia) {
      prevProps.cancelHelpTextTimeout();
      this.props.startHelpTextTimeout();
      const oldVideo = window.Wistia.api(prevProps.videoId);
      if (oldVideo) {
        this.unbindWistiaVideoEvents(oldVideo);
        oldVideo.replaceWith(this.props.videoId);
        window._wq = window._wq || [];
        window._wq.push({
          id: this.props.videoId,
          options: this.getOptionsFromProps(this.props.color, this.props.autoPlay, this.props.captionsOnByDefault),
          onReady: video => {
            this.props.cancelHelpTextTimeout();
            video.playbackRate(this.props.videoPlaySpeed / 100);
            this.bindWistiaVideoEvents(video);
            if (this.props.autoPlay) {
              video.play();
            }
            if (this.props.onReady) {
              this.props.onReady();
            }
            return video.unbind;
          }
        });
        prevProps.onChangeVideo();
      }
    } else if (prevProps.videoPlaySpeed !== this.props.videoPlaySpeed) {
      window._wq = window._wq || [];
      window._wq.push({
        id: this.props.videoId,
        onReady: video => {
          video.playbackRate(this.props.videoPlaySpeed / 100);
        }
      });
    }
  }
  componentWillUnmount() {
    const maybeVideo = window.Wistia ? window.Wistia.api(this.props.videoId) : false;
    if (maybeVideo) {
      maybeVideo.remove();
    }
  }
  getOptionsFromProps(color, autoPlay, captionsOnByDefault) {
    return {
      playerColor: color && color.replace('#', ''),
      videoFoam: true,
      autoPlay,
      plugin: {
        'captions-v1': {
          onByDefault: captionsOnByDefault
        }
      }
    };
  }
  bindWistiaVideoEvents(video) {
    const {
      onPlay,
      onFinish,
      onPause,
      onUpdateProgress
    } = this.props;
    if (this.mostRecentBound !== video.hashedId()) {
      if (onPlay) {
        video.bind('play', onPlay);
      }
      if (onPause) {
        video.bind('pause', onPause);
      }
      if (onFinish) {
        video.bind('end', onFinish);
      }
      if (onUpdateProgress) {
        video.bind('crosstime', 10, onUpdateProgress);
      }
      this.mostRecentBound = video.hashedId();
    }
  }
  unbindWistiaVideoEvents(video) {
    const {
      onPlay,
      onFinish,
      onPause,
      onUpdateProgress
    } = this.props;
    if (onPlay) {
      video.unbind('play', onPlay);
    }
    if (onPause) {
      video.unbind('pause', onPause);
    }
    if (onFinish) {
      video.unbind('end', onFinish);
    }
    if (onUpdateProgress) {
      video.unbind('crosstime', 10, onUpdateProgress);
    }
    return video.unbind;
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      className: `wistia_embed wistia_async_${this.props.videoId}`,
      style: {
        width: '100%',
        height: '100%'
      }
    });
  }
}
WistiaVideoPlayer.propTypes = {
  autoPlay: PropTypes.bool,
  cancelHelpTextTimeout: PropTypes.func.isRequired,
  captionsOnByDefault: PropTypes.bool,
  color: PropTypes.string,
  onFinish: PropTypes.func,
  onPause: PropTypes.func,
  onPlay: PropTypes.func,
  onReady: PropTypes.func,
  onChangeVideo: PropTypes.func,
  onUpdateProgress: PropTypes.func,
  startHelpTextTimeout: PropTypes.func.isRequired,
  videoId: PropTypes.string.isRequired,
  videoPlaySpeed: PropTypes.number
};
export default withPauseAndHelpLogic(WistiaVideoPlayer);